import OutcomesTable from "./OutcomesTable";

export default OutcomesTable;